import React from 'react';
import { GaugeContainer, GaugeFill } from './Gauge.styles';

const ThreeFourGauge: React.FC = () => {
  return (
    <GaugeContainer>
      <GaugeFill width="75%" color="#FC324A" />
    </GaugeContainer>
  );
};

export default ThreeFourGauge;
